function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import every from 'lodash/every';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import takeWhile from 'lodash/takeWhile';
import takeRightWhile from 'lodash/takeRightWhile';
import { mapState, mapGetters } from 'vuex';
export default {
  created: function created() {
    this.addPivotIfNeeded();
  },
  mounted: function mounted() {
    // Preserve query when changing between collocations and matching expressions
    this.updateView();
  },
  computed: _objectSpread({}, mapState({
    elementsType: function elementsType(s) {
      return s.elements.type;
    },
    elements: function elements(s) {
      return s.elements.left;
    }
  }), {}, mapGetters({
    isPresent: 'elements/at',
    resultType: 'api/formResultType'
  }), {
    fields: function fields() {
      return this.$ncsConfig.result[this.resultType].elements.tokens.fields;
    },
    elementsLength: function elementsLength() {
      return this.elements.length;
    },
    maxElements: function maxElements() {
      return get(this.$ncsConfig.result[this.resultType], 'elements.maximum', 0);
    },
    maxTokens: function maxTokens() {
      // Do not allow to put all allowed elements as pivots
      return this.leftElementsLength === 0 && this.rightElementsLength === 0 ? this.maxElements - 1 : this.maxElements;
    },
    leftElementsLength: function leftElementsLength() {
      if (every(this.elements, this.isStar)) {
        return 0;
      } else {
        return Math.min(takeWhile(this.elements, this.isStar).length, this.maxElements - 1);
      }
    },
    rightElementsLength: function rightElementsLength() {
      return Math.min(takeRightWhile(this.elements, this.isStar).length, this.maxElements - 1);
    },
    pivotElements: function pivotElements() {
      return this.elements.slice(this.leftElementsLength, this.elements.length - this.rightElementsLength);
    }
  }),
  watch: {
    elements: function elements() {
      this.updateView();
    }
  },
  methods: {
    isStar: function isStar(element) {
      var fieldsMinusToken = Object.keys(this.fields).filter(function (f) {
        return f !== 'token';
      });

      var isEmptyField = function isEmptyField(f) {
        return !element[f] || !element[f].value || isEmpty(element[f].value);
      };

      return element.token.value === '*' && every(fieldsMinusToken, isEmptyField);
    },
    onChange: function onChange() {
      var elements = [];
      var rightElements = Math.min(this.$refs.rightElements.value, this.maxElements - this.pivotElements.length);
      var leftElements = Math.min(this.$refs.leftElements.value, this.maxElements - this.pivotElements.length - rightElements);

      for (var i = 0; i < leftElements; ++i) {
        elements.push({
          token: {
            value: '*'
          }
        });
      }

      elements = [].concat(_toConsumableArray(elements), _toConsumableArray(this.pivotElements));

      for (var _i = 0; _i < rightElements; ++_i) {
        elements.push({
          token: {
            value: '*'
          }
        });
      }

      this.setElements(elements);
    },
    updateView: function updateView() {
      this.$refs.leftElements.value = this.leftElementsLength;
      this.$refs.rightElements.value = this.rightElementsLength;
      this.addPivotIfNeeded();
    },
    addPivotIfNeeded: function addPivotIfNeeded() {
      if (this.pivotElements.length === 0) {
        this.$store.commit('elements/addElement', {
          side: 'left',
          index: 0
        });
      }
    },
    setElements: function setElements(elements) {
      this.$store.commit('elements/setElements', {
        left: elements
      });
    },
    addPivotElement: function addPivotElement(i) {
      this.$store.commit('elements/addElement', {
        side: 'left',
        index: i
      });
    },
    removePivotElement: function removePivotElement(i) {
      this.$store.commit('elements/removeElement', {
        side: 'left',
        index: i
      });
    }
  }
};